import produce from "immer";

const actionTypes = {
  SET_ERROR: "SET_ERROR",
  INPUT_CHANGE: "INPUT_CHANGE",
  SET_CONTENT: "SET_CONTENT",
  CLEAR_CONTENT: "CLEAR_CONTENT"
};

export const actions = {
  setError: error => ({
    type: actionTypes.SET_ERROR,
    error
  }),
  inputChange: value => ({
    type: actionTypes.INPUT_CHANGE,
    value
  }),
  setContent: content => ({
    type: actionTypes.SET_CONTENT,
    content
  }),
  clearContent: () => ({
    type: actionTypes.CLEAR_CONTENT
  })
};

export const initialState = {
  validationError: null,
  inputValue: "",
  content: null
};

export const reducer = (state, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case actionTypes.SET_ERROR:
        draft.validationError = action.error;
        draft.content = null;

        break;

      case actionTypes.INPUT_CHANGE:
        draft.validationError = null;
        draft.inputValue = action.value;
        break;

      case actionTypes.SET_CONTENT:
        draft.content = action.content;
        draft.validationError = null;
        draft.inputValue = "";
        break;

      case actionTypes.CLEAR_CONTENT:
        draft.content = null;
        break;
    }
  });
};
